import * as actions from "../actions/index";

const initialState = {
  tourSteps: null,
};

const ICReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_TOUR_STEPS:
      return {
        ...state,
        tourSteps: action.payload,
      };

    default:
      return state;
  }
};
export default ICReducer;
